/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const r={linear:0,rectangular:1,circular:2},e={isAbsolute:0,isDiscrete:1};export{e as bitset,r as gradientFillMethods};
